module.exports = __webpack_public_path__ + "static/img/andromaster_0120.d87ef65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/andromaster_0120.jpg
// module id = y7HL
// module chunks = 0